import { render, staticRenderFns } from "./CropCard.vue?vue&type=template&id=4f3dd95a"
import script from "./CropCard.vue?vue&type=script&lang=js"
export * from "./CropCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports